export default __webpack_public_path__ + "static/game-intro-05-0344b6b8d227c7533376750d1cd0f8bb.png";